export function not(expression: any): boolean {
  return !expression;
}
